export default "__VITE_ASSET__D4n99cl9__"